<template>
  <section>
    <router-view/>
  </section>
  <FooterPage />
</template>

<script setup>
  import FooterPage from './components/FooterPage.vue'
	import { useRouter } from 'vue-router'
  
  const router = useRouter()  
</script>

<style lang="css" src="./assets/css/bootstrap.min.css"></style>
<style lang="css" src="./assets/css/custom.css"></style>
